import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
export const AjaxSpinner = (_props) => {
    const ajax_spinner = useAppSelector(state => state.app.ajax_spinner);
    const className = ajax_spinner ? 'ajax-spinner ajax-spinner-active' : 'ajax-spinner ajax-spinner-inactive';
    return (_jsx("div", { className: className, children: "V\u00E4nta..." }));
};
